import React from 'react';
import { Text, HStack, NumberInput, NumberInputField, NumberIncrementStepper, NumberInputStepper, NumberDecrementStepper, Box, Tooltip } from '@chakra-ui/react';
import Notification from './Notification';

function InputOption({ text, setSendValues, sendValues, invalidInput }) {

    return (<Box >
        <Tooltip
            color='black'
            fontSize='12px'
            placement='top'
            label="Put 0 for unbounded verification."
            aria-label='Volume tooltip'
            bg='gray.100' >
            <HStack spacing='24px' ml={100}>
                <Text
                    //  color='white' 
                    fontSize='14px'>{text}</Text>
                <NumberInput
                    bg='white'
                    min={0}
                    ml={10}
                    width="100px"
                    defaultValue={0}
                    isInvalid={invalidInput}
                    onChange={(value) => setSendValues({ ...sendValues, volume: value })}
                    size='12px'>
                    <NumberInputField height="30px" />
                    <NumberInputStepper >
                        <NumberIncrementStepper height="10px" />
                        <NumberDecrementStepper height="40px" />
                    </NumberInputStepper>
                </NumberInput>
            </HStack >
        </Tooltip>
        {invalidInput ? <Notification infoText="Volume should starts from 0" /> : null}
    </Box>
    );
}

export default InputOption;
